<template>
  <div>
    <action-icon
      icon="UploadIcon"
      :tooltip="$t('upload_file')"
      @click="openModalUploadFile()"
    />
    <vs-popup
      :title="$t('upload_file') | capitalize"
      :active.sync="openModalUpload"
      @close="closeModalUploadFile"
      :id="loadingPage"
      class="vs-con-loading__container"
    >
      <div>
        <vs-row vs-w="12" class="w-full">
          <qb-upload
            :showUploadButton="false"
            @update-file="handleManualFileUpdate"
            @on-delete="handleManualFileDelete"
            multiple
            :reset="reset"
            v-if="openModalUpload"
            accept="image/*,application/pdf,.doc,.docx"
          />
          <!-- :limit="2"  -->
          <vs-button
            color="primary"
            icon-pack="feather"
            icon="icon-upload"
            type="filled"
            class="mr-6 w-full"
            :disabled="files == null || files == []"
            @click="saveFiles"
          >
            {{ $t('save') }}
          </vs-button>
        </vs-row>
      </div>
    </vs-popup>
  </div>
</template>
<script>
import ActionIcon from '@/views/qb-components/actions/ActionIcon'
import QbUpload from '@/components/upload/QbUpload.vue'
import repse from '../../requests/repse.js'
import loading from '@/mixins/Loading'

export default {
  components: {
    ActionIcon,
    QbUpload,
  },
  props: {
    documentID: {
      type: String,
      default: '0',
    }
  },
  data: () => ({
    openModalUpload: false,
    files: null,
    reset:false
  }),
  methods: {
    openModalUploadFile() {
      this.openModalUpload = true
    },
    closeModalUploadFile() {
      this.files = new Array()
      this.handleManualFileDelete()
    },

    handleManualFileUpdate: function (e) {
      this.files =  [ ...e ]
    },
    handleManualFileDelete(e) {
      let i = this.files.findIndex((item) => item === e)
      this.files.splice(i, 1)
    },
    saveFiles: function () {
      this.openLoading(this.loadingPage)
      let form = new FormData()
      this.files.forEach(function (file, i) {
        form.append('files[]', file)
      })
      form.append('requestId', this.documentID)
      repse
        .uploadFile(form)
        .then((response) => {
          this.files = null
          this.openModalUpload = false

          this.$emit('refresh')
          this.$vs.notify({
            color: 'success',
            title: 'Success',
            text: 'uploaded document',
          })
          this.closeLoading(this.loadingPage)
        })
        .catch((response) => {
          this.showValidationErrors(response)
        })

      this.closeLoading(this.loadingPage)
    },
  },
  
  computed:{
    loadingPage(){
      return 'repse-requests-upload-modal-loading' + this.documentID
    } 
  },
  mixins: [loading],
}
</script>
